// lib/access/fater3dAccess.ts
//
// Who can open Fater 3D, while it is being built: a CLOSED list of individual users by User.id, the
// people building it, as Slides does (lib/access/slidesAccess.ts). To grant access, add an id and say
// who it is; to open the module, delete this file rather than growing the list into a permission system.
import type { UserContext } from '#types/types';

const FATER_3D_USER_IDS: ReadonlySet<string> = new Set([
  '665f5c236de32fb66dad6c81', // Jonathann Jacobs, jonathann@fater.ai
  '680f5aefb1c5d15b63103e4e', // Jonathann Jacobs, jonathannjvp@gmail.com
  '66146f123b47aef3810c55ba', // Youssef Guessous, yg@fater.ai
  '69769fa7169ae03c28659dd6', // Youssef Guessous, youssef@fater.ai
  '67f668c9fc596a2542e2dc3e', // Nabil Guessous, guessnabil@outlook.com
  'cmuzpyruj0001xqbizttb39l6', // Nabil Guessous, nabil@fater.ai (preview sign-in)
]);

// Every member of the Fater team too (owner, 2026-10-12: Valvert open to the team to check), client accounts never.
export const canAccessFater3D = (user: Pick<UserContext, 'dbUserId' | 'isFaterOrgMember'> | { dbUserId?: string | null; isFaterOrgMember?: boolean } | null | undefined): boolean =>
  (typeof user?.dbUserId === 'string' && FATER_3D_USER_IDS.has(user.dbUserId)) || user?.isFaterOrgMember === true;
